import "./App.css";
import React from "react";
import Footer from "./Component/Footer";
import Navbar from "./Component/Navbar";
import { BrowserRouter as Router } from "react-router-dom";
import MainContent from "./Component/MainContent";

const App = () => {
  return (
    <div className="App">
      <Router>
        <Navbar title="Mutant Potato" />
        <MainContent />
        <Footer />
      </Router>
    </div>
  );
};

export default App;
